import React from 'react'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import StepIndicator from '../footer/StepIndicator';
import StepSelector from '../footer/StepSelector';
import OptionsTitle from '../options-forms/OptionsTitle';
import DynamicForms from '../options-forms/dynamic/DynamicForms'
const OptionsModal = (props) => {
   const {
      open,
      setOpen,
      currentStepIndex,
      listData,
      validateCurrentOptionForm,
      formState,
      setFormState,
      basketState,
      setBasketState,
      handleOnslid
   } = props


   return (
      <Modal show={open} onHide={() => setOpen(false)} fullscreen={true} >
         <Modal.Header closeButton>
            <OptionsTitle currentStepIndex={currentStepIndex} listData={listData} />
         </Modal.Header>
         <Modal.Body className='pt-0'>
            <DynamicForms
               basketState={basketState}
               setBasketState={setBasketState}
               onSlid={handleOnslid}
               scrollOnError={false}
               open={open}
               setOpen={setOpen}
               validateCurrentOptionForm={validateCurrentOptionForm}
               currentStepIndex={currentStepIndex}
               listData={listData}
               formState={formState}
               setFormState={setFormState}
               closeOnSelect={true}

            />
         </Modal.Body>
         <Modal.Footer>
            <Container>
               <Row>
                  <Col md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} xxl={{ span: 4, offset: 4 }}>
                     <StepIndicator {...props} />
                  </Col>
               </Row>
               <Row>
                  <Col md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} xxl={{ span: 4, offset: 4 }}>
                     <StepSelector {...props} />
                  </Col>
               </Row>
            </Container>
         </Modal.Footer>
      </Modal>
   )
}
export default OptionsModal